import React, { useCallback, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Box,
  Divider,
} from "@mui/material";
import {
  serviceGetRewardHistory,
  serviceGetWalletHistory,
} from "../../../../services/Reward.service";
import { useParams } from "react-router-dom";
import { OutlineButton } from "../../../../components/Buttons/PrimaryButton";
import styles from "./Style.module.css";

const DataAccordion = ({ titles, type }) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { id } = useParams();
  const req =
    type === "reward" ? serviceGetRewardHistory : serviceGetWalletHistory;
  console.log("type", type);
  const handleViewRecords = useCallback(
    (progId) => {
      setLoading(true);
      if (expanded === progId) {
        setData(null);
        setExpanded(false);
      } else {
        setExpanded(progId);
        req({
          program_id: progId,
          user_id: id,
        }).then((res) => {
          if (!res.error) {
            const resData = res?.data || [];
            setData(resData);
          }
          setLoading(false);
        });
      }
    },
    [expanded, id]
  );

  console.log("data", data);
  return (
    <div className={styles.dataWrap}>
      {titles?.map((item, groupIndex) => (
        <Accordion
          key={item?.id}
          expanded={expanded === item?.id}
          className={styles.AccordianWrap}
          onChange={() => {}}
        >
          <AccordionSummary
            aria-controls={`panel${groupIndex}-content`}
            id={item?.id}
            key={`panel_acc_${groupIndex}-header`}
            sx={{ pointerEvents: "none" }}
          >
            <Box
              className={styles.BoxWrap}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography variant="h5">{item?.name}</Typography>
              <Box sx={{ pointerEvents: "auto" }}>
                <OutlineButton
                  variant="outlined"
                  sx={{ mr: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewRecords(item?.id);
                  }}
                >
                  {expanded === item?.id ? type === "reward" ? "HIDE REWARDS" : "HIDE WALLET" :  type === "wallet" ? "VIEW WALLET" : "VIEW REWARDS" }
                </OutlineButton>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <div className={styles.spinner}>
                <CircularProgress size={40} style={{ marginLeft: "10px" }} />
              </div>
            ) : (
              <Box sx={{ width: "100%", padding: "20px" }}>
                {data?.map((rewardItem, index) => (
                  <Box key={index} sx={{ padding: "10px 0" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box sx={{ flex: "1" }}>
                        <Typography variant="body1">
                          {rewardItem?.title}
                        </Typography>
                      </Box>

                      {type === "wallet" && (
                        <Box sx={{ flex: "1", textAlign: "center" }}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            className={
                              rewardItem?.transaction_type === "CREDIT"
                                ? styles.positive
                                : styles?.negative
                            }
                          >
                            {rewardItem?.transaction_type === "CREDIT"
                              ? "+"
                              : "-"}
                            {rewardItem?.points}
                          </Typography>
                        </Box>
                      )}
                      <Box sx={{ flex: "1", textAlign: "center" }}>
                        <Typography variant="body2" color="textSecondary">
                          {type === "reward"
                            ? `${rewardItem?.points || "-"} pts`
                            : `Balance : ${rewardItem?.program_closing_balance} pts`}
                        </Typography>
                      </Box>

                      <Box sx={{ flex: "1", textAlign: "center" }}>
                        <Typography variant="body2" color="textSecondary">
                          {rewardItem?.createdAtText}
                        </Typography>
                      </Box>
                    </Box>
                    {index < data?.length - 1 && <Divider />}
                  </Box>
                ))}
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default DataAccordion;
